import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { SupportIntegrationUrlConfig } from '../config/support-integaration-url.config';

@Injectable({
  providedIn: 'root'
})
export class supportIntegrationService {
    constructor (private httpService:HttpService) {}

    getReportDetails(params){
        return this.httpService.get(SupportIntegrationUrlConfig.Endpoints.supportIntegrationBaseUrl + SupportIntegrationUrlConfig.Endpoints.feedback.getReportDetails.replace('{params}',params))
    }

    getDocumentList(params){
        return this.httpService.get(SupportIntegrationUrlConfig.Endpoints.supportIntegrationBaseUrl + SupportIntegrationUrlConfig.Endpoints.feedback.getDocumentList.replace('{params}',params))
    }

    generateTicket(payload){
        return this.httpService.post(SupportIntegrationUrlConfig.Endpoints.supportIntegrationBaseUrl + SupportIntegrationUrlConfig.Endpoints.ticket.generateTicket,payload)
    }

    addAttchment(payload){
        return this.httpService.post(SupportIntegrationUrlConfig.Endpoints.supportIntegrationBaseUrl + SupportIntegrationUrlConfig.Endpoints.feedback.addAttachment,payload)
    }

    addIncidentReport(payload){
        return this.httpService.post(SupportIntegrationUrlConfig.Endpoints.supportIntegrationBaseUrl + SupportIntegrationUrlConfig.Endpoints.feedback.addIncidentReport,payload)
    }

    getIncidentReportList(params){
        return this.httpService.get(SupportIntegrationUrlConfig.Endpoints.supportIntegrationBaseUrl + SupportIntegrationUrlConfig.Endpoints.ticket.getReportList.replace('{params}',params))
    }

    getProjectInfo(params){
        return this.httpService.get(SupportIntegrationUrlConfig.Endpoints.supportIntegrationBaseUrl + 
            SupportIntegrationUrlConfig.Endpoints.ticket.getProjectInfo +params
        )
    }
    
}